export default __webpack_public_path__ + "static/media/b.8487de81.png";